<script lang="ts">
const __DsBlock = {
	hidden: true,
	category: 'file-preview',
	tags: ['image/'],
	events: [
		{
			name: 'remove',
			payload: [],
		},
	],
}
</script>
<script lang="ts" setup>
import type { FileInfoActionOverlayAction } from '#layers/assets/components/FileInfoActionOverlay.vue';
import type { FilePreviewBlockEmits, FilePreviewBlockProps } from '#layers/assets/types/file-preview';
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAppConfig } from '#app/config';
import RenderAssetImage from '#layers/assets/components/RenderAssetImage.vue';
import { defineBlock } from '#layers/block-engine/public';

const { file, showRemove = true } = defineProps<FilePreviewBlockProps>();

defineEmits<FilePreviewBlockEmits>();

;

const appConfig = useAppConfig();
const { t } = useI18n();
const isQuickLookOpen = ref(false);
const restoreQuickLookFocus = ref(true);
const quickLookActions = computed<FileInfoActionOverlayAction[]>(() => [
	{
		id: 'quick-look',
		label: t('file_preview.image.open_quick_look'),
		icon: appConfig.ui.icons.enterFullscreen,
		onClick: openQuickLook,
	},
]);

function openQuickLook(event?: MouseEvent) {
	restoreQuickLookFocus.value = event?.detail === 0;
	isQuickLookOpen.value = true;
}
</script>

<template>
	<div class="group relative aspect-video max-h-[300px] overflow-hidden rounded-lg bg-muted">
		<RenderAssetImage
			:file
			class="size-full object-contain"
		>
			<template #error>
				<FileLoadError />
			</template>
		</RenderAssetImage>

		<FileInfoActionOverlay :file :show-remove download :leading-actions="quickLookActions" @remove="$emit('remove')" />

		<FilePreviewImageQuickLook v-model:open="isQuickLookOpen" :file :restore-focus-on-close="restoreQuickLookFocus" />
	</div>
</template>
